/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from "react";
import styles from "./tasks.module.css";
import "../App.css";
import {
  Button,
  Modal,
  TextInput,
  Loader,
  Text,
  Textarea,
} from "@mantine/core";
import { useParams } from "react-router-dom";
import { LinkBreak1Icon, Pencil1Icon, TrashIcon } from "@modulz/radix-icons";
import { RichTextEditor } from "@mantine/rte";
import { useDropzone, FileWithPath } from "react-dropzone";
import PropTypes from "prop-types";
import { getTask, submitTaskApi, deleteSubApi, getTaskFileUrl } from "../api/tasks";
import { showNotification, updateNotification } from "@mantine/notifications";
import { Badge } from "@mantine/core";
import moment from "moment";

const type = localStorage.getItem("type");

function Part1({ task }) {
  return (
    <div className={styles.part1}>
      <h1 className={styles.heading}>TASK {task.taskNo}</h1>
      <Badge color={"gray"} variant="filled">
        {task.domain.name}
      </Badge>
      {/* <h2 className={styles.domain}>{task.domain.name}</h2> */}
      <div className={styles.deadline}>
        <p className={styles.deadlinetitle}>Deadline</p>
        <p className={styles.date}>
          {moment(new Date(task.deadline)).format("MMMM Do YYYY")}
        </p>
      </div>
    </div>
  );
}

function Information({ task }) {
  const [download, setDownload] = useState("www.github.com");
  const [load1, setLoad1] = useState(false);
  const [load2, setLoad2] = useState(false);
  const [isReadMore, setIsReadMore] = useState(false);
  const [fileUrl, setFileUrl] = useState("");

  const initialValue = "Submit your work here";
  // const [text, setText] = useState(task.content);

  useEffect(() => {
      const loadUrl = async () => {
          try {
              const res = await getTaskFileUrl(task.fileName);
              setFileUrl(res.data.url);
          } catch(err) {
              console.log(err);
          }
      };
      loadUrl();
  }, [task.fileName]);

  return (
    <div>
      <p className={styles.information}>Information</p>
      {type == "ADMIN" && (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {task.showResult == false ? (
            <></>
          ) : (
            <Button
              style={{ marginTop: "20px" }}
              className={styles.download}
              disabled
              type="submit"
            >
              RESULTS DECLARED
            </Button>
          )}
        </div>
      )}
      {/* <Text>{text}</Text> */}
      {/* <RichTextEditor value={task.content}></RichTextEditor> */}
      {task.content.length <= 200 && (
        <Text className={styles.rte1}>{task.content}</Text>
      )}
      {!isReadMore && task.content.length > 200 && (
        <Text className={styles.rte1}>
          {task.content.substr(0, 197)}...
          <span
            onClick={() => {
              setIsReadMore(!isReadMore);
            }}
          >
            <span style={{ color: "#3cff3c" }}>Read More</span>{" "}
          </span>
        </Text>
      )}
      {isReadMore && task.content.length > 200 && (
        <Text className={styles.rte1}>
          {task.content}
          <span
            onClick={() => {
              setIsReadMore(!isReadMore);
            }}
          >
            <span style={{ color: "#ff5050" }}>Show Less</span>{" "}
          </span>
        </Text>
      )}
      <div className={styles.filerow}>
        <Button
          className={styles.download}
          variant="outline"
          component="a"
          target="_blank"
          href={fileUrl}
        >
          DOWNLOAD TASK
        </Button>
      </div>
    </div>
  );
}

function Submission({ task }) {
  const initialValue = "Submit your work here";
  const [link, setLink] = useState(null);
  const [text, setText] = useState(null);
  const [edit, setEdit] = useState(false);
  const [opened, setOpened] = useState(false);
  const [myFiles, setMyFiles] = useState([]);
  const onDrop = (acceptedFiles) => {
    setMyFiles([...acceptedFiles]);
  };

  const handleSub = async (text) => {
    showNotification({
      id: "subTask",
      title: "Submitting Task",
      loading: true,
      autoClose: false,
      disallowClose: true,
    });
    //console.log(file);
    const file = null;
    if (!link || link.trim().length == 0) {
      updateNotification({
        id: "subTask",
        title: "ERROR",
        message: "Please upload zip or submission link",
        color: "red",
      });
      setEdit(false);
      return;
    }
    const formData = new FormData();
    formData.append("link", link);
    formData.append("content", text);
    formData.append("submission", file);
    formData.append("taskId", task.id);

    const res = await submitTaskApi(formData).catch((err) => {
      updateNotification({
        id: "subTask",
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403) {
        localStorage.clear();
        window.location.replace("/");
      }
      return;
    });
    if (res != null) {
      if (res.status == 200) {
        updateNotification({
          id: "subTask",
          title: "Success",
          message: res.data.message,
          color: "green",
        });
      } else {
        updateNotification({
          id: "subTask",
          title: "ERROR",
          message: res.data.message,
          color: "red",
        });
        return;
      }
    }
  };

  return (
    <div>
      {/* <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title={<p className={styles.modaltitle}>Upload File</p>}
      >
        <div {...getRootProps({ className: "dropzone" })}>
          <input {...getInputProps()} />
          <div className={styles.dropzone}>
            <p>Drag and Drop/Select your project file (zip) here.</p>
          </div>
        </div>
        <div className={styles.files}>
          <ul>{files}</ul>
          <Button
            style={{
              display: files.length != 0 ? "inline" : "none",
              backgroundColor: "red",
            }}
            onClick={() => {
              setMyFiles([]);
            }}
          >
            REMOVE FILE
          </Button>
        </div>
      </Modal> */}

      {task.showResult == false && task.subAllowed == true ? (
        // <>
        //   {edit == false ? (
        <>
          {/* <div className={styles.inforow}> */}
          <p className={styles.information}>Submission</p>

          {/* </div> */}
          <Text styles={{ color: "white" }}>
            NOTE : Upload link. Content is not mandatory
          </Text>
          <Textarea
            required
            className={styles.rte}
            autosize
            minRows={4}
            placeholder="Give a brief explanation about your submission."
            value={text}
            onChange={(e) => {
              setText(e.target.value);
            }}
          />

          <p className={styles.asset}>Link to your project : </p>
          <div className={styles.editrow}>
            <TextInput
              required
              className={styles.editlink}
              variant="unstyled"
              placeholder="Please submit your project link here"
              onChange={(event) => setLink(event.currentTarget.value)}
            />
            {/* <div className={styles.icon}> */}
            <Button
              className={styles.submit}
              variant="outline"
              type="submit"
              onClick={() => {
                setEdit(true);
                handleSub(text, myFiles[0]);
              }}
            >
              Submit
            </Button>
            {/* </div> */}
          </div>
        </>
      ) : (
        //   ) : (
        //     <>
        //       <div>
        //         <p className={styles.information}>Submission</p>
        //       </div>
        //       {/* <div className={styles.text}> */}
        //       <Textarea
        //         required
        //         autosize
        //         className={styles.rte}
        //         value={text}
        //         readOnly
        //       />

        //       <div className={styles.filerow}>
        //         {files.length == 0 ? (
        //           <Button
        //             className={styles.download}
        //             variant="outline"
        //             type="submit"
        //             onClick={() => setOpened(true)}
        //           >
        //             {" "}
        //             UPLOAD FILE
        //           </Button>
        //         ) : (
        //           <Button
        //             className={styles.download2}
        //             variant="outline"
        //             type="submit"
        //             onClick={() => setOpened(true)}
        //           >
        //             {" "}
        //             REUPLOAD
        //           </Button>
        //         )}
        //         <ul className={styles.files}>{files}</ul>
        //         <Button
        //           className={styles.download2}
        //           variant="outline"
        //           type="submit"
        //           onClick={() => handleDelSub()}
        //         >
        //           {" "}
        //           DELETE FILE
        //         </Button>
        //       </div>
        //       <p className={styles.asset}>Link to your project : </p>
        //       <div className={styles.editrow}>
        //         <TextInput
        //           required
        //           className={styles.editlink}
        //           variant="unstyled"
        //           value={link}
        //           readOnly
        //         />
        //         {/* <Button
        //           className={styles.pencil}
        //           variant="subtle"
        //           type="submit"
        //           onClick={() => setEdit(false)}
        //         >
        //           <Pencil1Icon />
        //         </Button> */}
        //       </div>
        //     </>
        //     )
        //     }
        // </>
        <>
          <div>
            <p className={styles.information}>Submission</p>
            <p
              style={{
                color: "#2cc194",
                fontWeight: "700",
                marginLeft: "2vmax",
                marginRight: "2vmax",
                fontSize: "17px",
              }}
            >
              {" "}
              Submissions have been closed.{" "}
            </p>
          </div>
        </>
      )}
    </div>
  );
}

async function getTaskF(id) {
  const res = await getTask(id).catch((err) => {
    showNotification({
      title: "ERROR",
      message:
        err.response != null
          ? err.response.data != null
            ? err.response.data.message != null
              ? err.response.data.message
              : err.message
            : err.message
          : err.message,
      color: "red",
    });
    return;
  });
  if (res.status == 200) {
    //console.log(res.data);
    return res.data;
  } else {
    showNotification({
      title: "ERROR",
      message: res.data.message,
      color: "red",
    });
    return [];
  }
}
function TaskPage() {
  let { id } = useParams();
  const [task, setTask] = useState({});
  const [load, setLoad] = useState(true);
  useEffect(() => {
    getTaskF(id).then((res) => {
      setLoad(false);
      setTask(res.task);
    });
  }, []);

  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div className={styles.body}>
          <Part1 task={task} />
          <div className={styles.part2}>
            <Information task={task} />
            <hr color="#6b709a" className={styles.line} />
            {type == "MENTEE" && <Submission task={task} />}
          </div>
        </div>
      )}
    </>
  );
}
Part1.propTypes = {
  task: PropTypes.object,
};
Information.propTypes = {
  task: PropTypes.object,
};
Submission.propTypes = {
  task: PropTypes.object,
};

export default TaskPage;
